import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ColorSwatches from '../components/product-detail/color-swatches/ColorSwatches';
import { productActions } from '../redux/product/actions/ProductActions';
import { makeGetAvailableColors, makeGetProductDefaults, makeGetSelectedColorId, } from '../redux/product/selectors/ProductSelector';
const ColorSwatchesContainer = ({ enableShopTheLook = false }) => {
    const { isShopLanding, feature_toggles: { categorized_product_features }, pageInfo: { isPDPPage }, productImageConfig, productSwatchConfig, } = useAemConfig();
    const dispatch = useDispatch();
    const colors = useSelector(makeGetAvailableColors());
    const productCode = useSelector(makeGetProductDefaults()).productCode;
    const selectedColorId = useSelector(makeGetSelectedColorId());
    useEffect(() => {
        if (isPDPPage && categorized_product_features && selectedColorId) {
            dispatch(productActions.createGetTechnicalCategories(selectedColorId));
        }
    }, []);
    const setProductColor = (colourId) => {
        dispatch(productActions.createSetColorAction(colourId));
        if (isPDPPage && categorized_product_features) {
            dispatch(productActions.createGetTechnicalCategories(colourId));
        }
        if (enableShopTheLook) {
            dispatch(productActions.createGetLinkedProducts(colourId));
        }
    };
    return (_jsx(ColorSwatches, { colors: colors, productCdnDomains: productImageConfig.cdnDomains, productCode: productCode, selectedColorId: selectedColorId, setProductColor: setProductColor, swatchInformation: productSwatchConfig, isShopLanding: isShopLanding }));
};
export default ColorSwatchesContainer;
